module.exports = __webpack_public_path__ + "static/media/dots2.f9406b9e.svg";